/**
 * Module-level logo cache.
 * All components share one Promise so the /api/logo network request
 * is made only once per page session, no matter how many components call it.
 * Also reuses data preloaded by the HTML <script> to avoid ANY duplicate.
 */
let _promise = null;
let _resolved = null;

export function fetchLogo() {
  if (!_promise) {
    // If the HTML <script> already fetched this, reuse that data
    if (typeof window !== 'undefined' && window.__preloadData?.logo && Object.keys(window.__preloadData.logo).length > 0) {
      _resolved = window.__preloadData.logo;
      _promise = Promise.resolve(_resolved);
    } else {
      _promise = fetch(`${process.env.REACT_APP_API_URL}/api/logo`)
        .then((res) => {
          if (!res.ok) throw new Error('logo fetch failed');
          return res.json();
        })
        .then((data) => (Array.isArray(data) ? data[0] : data) || {})
        .then((data) => { _resolved = data; return data; })
        .catch(() => { _resolved = {}; return {}; });
    }
  }
  return _promise;
}

/**
 * Returns the already-resolved logo data synchronously, or null if not yet fetched.
 * Use this as a lazy useState initializer so components that mount after the
 * first fetch skip the async round-trip entirely.
 */
export function getLogoSync() {
  return _resolved;
}

/** Call this to force a fresh fetch on the next call (e.g. after logout). */
export function clearLogoCache() {
  _promise = null;
  _resolved = null;
}
